import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import EKYC_UID_And_EKYC_UID_Remove from "./EKYC_UID_And_EKYC_UID_Remove"; // second page component
import CircularProgress from '@mui/material/CircularProgress';


const EkycUid = () => {
  const [uidNo, setUidNo] = useState("");
  const [showSecondPage, setShowSecondPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [sessionExpired, setSessionExpired] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}/api/session-info1`, { withCredentials: true })
      .then((res) => {
        const role = res.data?.userRole;
        setUserRole(role);

        if (!role || role !== "1" || role !== "2") {
          navigate("/login");
        }
      })
      .catch(() => {
        setSessionExpired(true);
        // navigate("/login"); // redirect on session failure
      });
  }, [navigate]);

  // 🔹 Form submission with validation
  const handleSubmit = () => {
    if (!uidNo || uidNo.trim() === "") {
      alert("Please Enter UID");
      return;
    }

    setLoading(true);

    setTimeout(() => {
      setShowSecondPage(true);
      setLoading(false);
    }, 1000);
  };

  // 🔹 Clear button
  const handleClear = () => {
    setUidNo("");
    setShowSecondPage(false);
    setLoading(false);
  };

  // 🔹 Block rendering if role not yet checked
  if (sessionExpired) {
    return (
      <div style={{ textAlign: "center", marginTop: "40px", color: "red" }}>
        Session expired. Please <a href="/login">login again</a>.
      </div>
    );
  }

  if (userRole === null) {
    return (
      <div style={{ textAlign: "center", marginTop: "40px" }}>
        Checking access...
      </div>
    );
  }

  if (userRole === "1" || userRole === "2") {
    return (
      <div className="wrapper row3">
        <div id="container">
          <table width="30%" align="center">
            <thead>
              <tr className="tableheader">
                <th colSpan={2}>UID Remove from eKYC</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <b>UID No:</b>
                </td>
                <td>
                  <input
                    placeholder="Enter UID Number"
                    type="text"
                    maxLength="12"
                    value={uidNo}
                    onChange={(e) => setUidNo(e.target.value)}
                    className="border rounded px-3 py-2 w-64"
                  />
                </td>
              </tr>

              <tr align="center">
                <td colSpan={2}>
                  <button onClick={handleSubmit} className="button button2">
                    Submit
                  </button>
                  <button onClick={handleClear} className="button button2">
                    Clear
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


        {/* Loading Indicator */}
        {loading && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <CircularProgress />
          </div>
        )}

        {/* Render second page neatly below first page */}
        {!loading && showSecondPage && (
          <div className="mt-8">
            <EKYC_UID_And_EKYC_UID_Remove uidOrRc={uidNo} />
          </div>
        )}
      </div>
    );

  }
};

export default EkycUid;
